export default __webpack_public_path__ + "static/media/Transformer_04.b6e0dd12.png";